import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from "prop-types";
import {render, unmountComponentAtNode} from "react-dom";
import ThemeProvider from "./ThemeProvider";

const AlertDialog = (props) => {
    const { title, children, confirmLabel = "Ok", open, setOpen, onConfirm } = props;

    function handleConfirm() {
        setOpen(false);
        onConfirm();
    }

    return (
        <Dialog
            open={open}
            onClose={handleConfirm}
            aria-labelledby="confirm-dialog"
            data-testid="confirm-dialog">
            <DialogTitle data-testid="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button data-testid="confirm-button"
                    variant="contained"
                    onClick={handleConfirm}
                    color="primary">
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

AlertDialog.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    setOpen: PropTypes.func
}

export default AlertDialog;

export const useAlertConfirmation = () => {
    return (title, message, confirmLabel = "Ok", cancelLabel = "Cancel") => {
        return new Promise((resolve) => {
            createAlertConfirmElement({
                title,
                children: message,
                confirmLabel,
                cancelLabel,
                open: true,
                setOpen: () => {},
                onConfirm: () => {
                    resolve(true)
                    removeAlertConfirmElement()
                },

            })
        })
    }
}

function createAlertConfirmElement ({children, ...props}) {
    let divTarget = document.getElementById('react-confirm')
    if (!divTarget) {
        divTarget = document.createElement('div')
        divTarget.id = 'react-confirm'
        document.body.appendChild(divTarget)
    }
    render(<ThemeProvider><AlertDialog {...props}>{children}</AlertDialog></ThemeProvider>, divTarget)
}

function removeAlertConfirmElement() {
    const target = document.getElementById('react-confirm')
    if (target) {
        unmountComponentAtNode(target)
        target.parentNode.removeChild(target)
    }
}